<template>
  <div class="flex-1">
    <tickets-list />
  </div>
</template>

<script lang="ts">
import { mapGetters } from "vuex";
import TicketsList from "./list/TicketsList.vue";

export default {
  name: "Tickets.vue",
  components: { TicketsList },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  methods: {},
};
</script>

